import { ChangeEvent } from 'react';
import { FieldValues } from 'react-hook-form';

import { ControlledTextFieldProps } from '../../../components/TextField/ControlledTextField';
import MaskedTextField from '../../../components/TextField/MaskedTextField';

const DateOfBirthTextField = <TFieldValues extends FieldValues = FieldValues>(
  props: ControlledTextFieldProps<TFieldValues>
) => (
  <MaskedTextField
    mask="##/##/####"
    placeholder="MM/DD/YYYY"
    definitions={{
      '#': /[0-9]/,
    }}
    onAccept={(value: string) => {
      return (
        props.onChange &&
        props.onChange({
          target: { name: props.name, value },
        } as unknown as ChangeEvent<HTMLInputElement>)
      );
    }}
    style={{
      fontKerning: 'none',
    }}
    overwrite
    // There is known bug with the react-imask library and the typings when using their mixin with custom Input components
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...(props as any)}
  />
);

export default DateOfBirthTextField;
